import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL ||
  `${window.location.protocol}//${window.location.hostname}:5000/api`;

const apiClient = axios.create({
  baseURL: API_URL,
  withCredentials: true, // ✅ IMPORTANT: Forces cookies to be sent/received
  headers: { "Content-Type": "application/json" },
});

// ✅ Automatically attach Bearer token to all requests if stored in localStorage
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("jwt_token");
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Automatically save token from responses that issue one, and clear if unauthorized /me
apiClient.interceptors.response.use(
  (response) => {
    if (response?.data?.token) {
      localStorage.setItem("jwt_token", response.data.token);
    }
    return response;
  },
  (error) => {
    if (error.response?.status === 401 && error.config?.url?.includes("/me")) {
      localStorage.removeItem("jwt_token");
    }
    return Promise.reject(error);
  }
);

console.log("API_URL:", API_URL);

export default apiClient;
export { API_URL };